import {
    ADD_GARAGE,
    UPDATE_GARAGE,
    DELETE_GARAGE,
    GET_GARAGES,
    GET_GARAGE,
    GARAGE_ERROR,
} from "../types";
// import axios from "axios";
import customAxios from "../../utils/customAxios";
import { setAlert } from "../alert";

// Network failures and timeouts carry no `err.response`, so reading `.status`
// off it threw a second error inside the catch and swallowed the real one.
const garageError = (err) => ({
    type: GARAGE_ERROR,
    payload: { msg: err.response?.data, status: err.response?.status },
});

const garageErrorMessage = (err) =>
    err.response?.data?.errors?.[0]?.msg ||
    err.response?.data?.msg ||
    err.response?.data?.status ||
    err.message ||
    "Something went wrong";

// Both resolve to { ok, message }. They used to end on `window.location.href = ...`,
// a full page reload straight to the list -- which threw away the React tree before
// the screen could say anything about what it had just written. The caller now
// confirms, reports, and navigates when the admin is done reading.
export const addGarage = (formData) => async (dispatch) => {
    try {
        const config = {
            headers: {
              "Content-Type": "application/json",
            },
          };
        const res = await customAxios.post(
            `/api/admin/garages`,
            formData,
            config
        );
        dispatch({
            type: ADD_GARAGE,
            payload: res.data.data,
        });

        return { ok: true };
    } catch (err) {
        dispatch(garageError(err));
        return { ok: false, message: garageErrorMessage(err) };
    }
};

export const updateGarage = (formData, id) => async (dispatch) => {
    try {
        const config = {
            headers: {
              "Content-Type": "application/json",
            },
          };
        const res = await customAxios.post(
            `/api/admin/garages/${id}`,
            formData,
            config
        );

        dispatch({
            type: UPDATE_GARAGE,
            payload: res.data.data,
        });

        return { ok: true };
    } catch (err) {
        dispatch(garageError(err));
        return { ok: false, message: garageErrorMessage(err) };
    }
};

export const getGarage = (id) => async (dispatch) => {
    // Drop whatever garage/error the slice is holding from a previous screen so
    // the edit form can tell "still loading" apart from "loaded the wrong one".
    dispatch({ type: GET_GARAGE, payload: null });

    try {
        const res = await customAxios.get(`/api/admin/garages/${id}`);
        dispatch({
            type: GET_GARAGE,
            payload: res.data,
        });
    } catch (err) {
        dispatch(garageError(err));
        dispatch(setAlert(garageErrorMessage(err), "danger"));
    }
};

export const getGarages = () => async (dispatch) => {
    try {
        const res = await customAxios.get(`/api/admin/garages`);
        dispatch({
            type: GET_GARAGES,
            payload: res.data,
        });
    } catch (err) {
        dispatch(garageError(err));
    }
};

export const deleteGarage = (id) => async (dispatch) => {
    try {
        const config = {
            headers: {
              "Content-Type": "application/json",
            },
          };
        const res = await customAxios.delete(
            `/api/admin/garages/del/${id}`,
            config
        );
        dispatch({
            type: DELETE_GARAGE,
            payload: res.data,
        });
        dispatch(setAlert("Garage Deleted", "success"));
    } catch (err) {
        dispatch(garageError(err));
        dispatch(setAlert(garageErrorMessage(err), "danger"));
    }
};